import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useHistory } from "react-router-dom";
import ReactPaginate from "react-paginate";

import { FilterClearIcon, FilterIcon, NoResultIcon } from "../svg";
import { dataServices } from "../../services/dataServices";
import { helpers, typeConst, orderListConst, pageSizeConst } from "../../services/utilities";
import { SettingsContext } from "../settingContext";
import Categories from "../categories";
import { LoadingComponent } from "../loading";

import "../search/Search.css";
import "../search/Search.mobile.css";

function Search() {
    const settings = React.useContext(SettingsContext);

    const mobileBreakPoint = 991.98;

    const maxTermsToShow = settings.maxterms;

    const maxFilters = settings.maxfilter;

    const history = useHistory();

    //State for showing/hiding filters in mobile view
    const [mobileFilterState, setMobileFilterState] = useState(false);

    //Hook for window resizing
    const size = useWindowSize();

    //State for showing spinner while fetching data from API
    const [loadingState, setLoadingState] = useState(true);

    //Initial application state
    var initialState = {
        keyword: "",

        selectedCategory: [],
        selectedCountry: [],
        selectedLanguage: [],
        selectedCrop: [],

        categories: [],
        countries: [],
        languages: [],
        crops: [],

        type: "",
        page: 1,
        pageSize: pageSizeConst[0],
        order: orderListConst[0],

        results: [],
        resultCount: 0,
        typecount: [
            {
                name: typeConst.allDevices,
                value: 0,
            },
            {
                name: typeConst.website,
                value: 0,
            },
            {
                name: typeConst.appleStore,
                value: 0,
            },
            {
                name: typeConst.playStore,
                value: 0,
            },
        ],

        orderList: [...orderListConst],
        pageSizeList: [...pageSizeConst],
    };

    //State for search
    const [appState, setAppState] = useState(initialState);

    useEffect(() => {
        //When page load get the filters and result
        searchPerformed(true, true);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //Method to get data from Management API and
    const searchPerformed = (includeFilter, analyticPush) => {
        const filters = helpers.getFilters(window.location.search);

        //Show loading
        setLoadingState(true);

        //Fetch data from API
        dataServices
            .search(
                filters.keyword,
                filters.categories,
                filters.countries,
                filters.languages,
                filters.crops,
                filters.type,
                filters.order,
                filters.page,
                filters.pageSize,
                includeFilter,
                settings
            )
            .then((response) => {
                if (response.status === 200) {
                    const data = response.data;

                    //Transform API data to state object
                    var newState = helpers.transformData(
                        appState,
                        filters,
                        data,
                        includeFilter
                    );

                    //Update state
                    setAppState(newState);

                    if (analyticPush === true) {
                        pushAnalytic(newState, settings);
                    }

                    //Hide loading UI
                    setLoadingState(false);
                }
            })
            .catch(function (error) {
                //If error hide loading state
                setLoadingState(false);
                console.log(error);
            });
    };

    //Category change event
    const onCategoryChange = (selectedOption) => {
        const newState = {
            ...appState,
            page: 1,
            selectedCategory: selectedOption,
        };
        setAppState(newState);

        helpers.updateHistory(history, newState);

        searchPerformed(false, true);
    };

    //Country change event
    const onCountryChange = (selectedOption) => {
        const newState = {
            ...appState,
            page: 1,
            selectedCountry: selectedOption,
        };
        setAppState(newState);

        helpers.updateHistory(history, newState);

        searchPerformed(false, true);
    };

    //Language change event
    const onLanguageChange = (selectedOption) => {
        const newState = {
            ...appState,
            page: 1,
            selectedLanguage: selectedOption,
        };
        setAppState(newState);

        helpers.updateHistory(history, newState);

        searchPerformed(false, true);
    };

    //Crop change event
    const onCropChange = (selectedOption) => {
        const newState = {
            ...appState,
            page: 1,
            selectedCrop: selectedOption,
        };
        setAppState(newState);

        helpers.updateHistory(history, newState);

        searchPerformed(false, true);
    };

    //Sort order change
    const onSortOrderChange = (selectedOption) => {
        if (appState.order == selectedOption) {
            return;
        }
        const newState = {
            ...appState,
            page: 1,
            order: selectedOption,
        };
        setAppState(newState);

        helpers.updateHistory(history, newState);

        searchPerformed(false, false);
    };

    //Sort order change
    const onPageSizeChange = (selectedOption) => {
        if (appState.pageSize == selectedOption) {
            return;
        }
        const newState = {
            ...appState,
            pageSize: selectedOption,
        };
        setAppState(newState);

        helpers.updateHistory(history, newState);

        searchPerformed(false, false);
    };

    //Keyword change event
    const onKeywordChange = (e) => {
        if (e.key === "Enter") {
            const newState = {
                ...appState,
                page: 1,
                keyword: e.target.value,
            };
            setAppState(newState);

            helpers.updateHistory(history, newState);

            searchPerformed(false, true);
        } else {
            const newState = {
                ...appState,
                keyword: e.target.value,
            };
            setAppState(newState);
        }
    };

    const onKeywordChanged = (e) => {
        const newState = {
            ...appState,
            keyword: e.target.value,
        };
        setAppState(newState);
    };

    //Clear all click event handler
    const clearAll = () => {
        setAppState(initialState);

        helpers.updateHistory(history, initialState);

        searchPerformed(true);
    };

    //Type change event handler
    const onTypeChange = (e) => {
        const newappState = {
            ...appState,
            page: 1,
            type: e.target.value,
        };
        setAppState(newappState);

        helpers.updateHistory(history, newappState);

        searchPerformed(false, true);
    };

    //Paging event
    const handlePageClick = (event) => {
        const newappState = {
            ...appState,
            page: event.selected + 1,
        };
        setAppState(newappState);

        helpers.updateHistory(history, newappState);

        searchPerformed(false, false);
    };

    //Method to get filter count for the mobile view
    const filtersCountForMobile = (state) => {
        let count = 0;

        if (appState.keyword) {
            count += 1;
        }
        if (Array.isArray(state.selectedCategory)) {
            count += state.selectedCategory.length;
        }
        if (Array.isArray(state.selectedCountry)) {
            count += state.selectedCountry.length;
        }
        if (Array.isArray(state.selectedLanguage)) {
            count += state.selectedLanguage.length;
        }
        if (Array.isArray(state.selectedCrop)) {
            count += state.selectedCrop.length;
        }

        count += state.type !== "" && state.type !== typeConst.allDevices ? 1 : 0;
        return count;
    };

    //Show more onclick event handler
    const onclickShowMore = (type, index) => {
        let newstate = { ...appState };

        if (type === "crop") {
            let oldValue = newstate.results[index].cropshowmore ?? false;

            newstate.results[index].cropshowmore = !oldValue;
        } else if (type === "country") {
            let oldValue = newstate.results[index].countryshowmore ?? false;

            newstate.results[index].countryshowmore = !oldValue;
        } else if (type === "language") {
            let oldValue = newstate.results[index].languageshowmore ?? false;

            newstate.results[index].languageshowmore = !oldValue;
        }
        else if (type === "category") {
            let oldValue = newstate.results[index].categoryshowmore ?? false;

            newstate.results[index].categoryshowmore = !oldValue;
        }
        setAppState(newstate);
    };

    const pushAnalytic = (state, settings) => {
        dataServices
            .analyticpush(
                state.keyword,
                state.selectedCategory,
                state.selectedCountry,
                state.selectedLanguage,
                state.selectedCrop,
                state.type,
                settings
            )
            .then((response) => {
                if (response.status !== 200) {
                    console.log(response);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    return (
        <div className="row">
            <div
                className={
                    size.width > mobileBreakPoint
                        ? "col-lg-3 filters"
                        : mobileFilterState
                            ? "col-lg-3 filters"
                            : "col-lg-3 filters hidden-mobile"
                }
            >
                <div className="row row-cols-1 content">
                    <div className="col header mb-2">
                        <span className="filter">
                            <FilterIcon />
                            Filter
                        </span>
                        <span
                            className="close-btn"
                            onClick={() => setMobileFilterState(false)}
                        >
                            &times;
                        </span>
                        <span className="clear noselect" onClick={clearAll}>
                            <FilterClearIcon /> Clear all
                        </span>
                    </div>
                    <div className="col mb-3">
                        <label className="keywordtext">
                            {
                                <input
                                    type="text"
                                    placeholder="Keyword search..."
                                    onChange={onKeywordChanged}
                                    onKeyDown={onKeywordChange}
                                    value={appState.keyword}
                                />
                            }
                        </label>
                    </div>
                    <div className="col mb-3">
                        <label className="label mb-2">Category</label>
                        <Select
                            isMulti
                            name="category"
                            options={appState.categories}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder="Select"
                            value={appState.selectedCategory}
                            onChange={onCategoryChange}
                        />
                    </div>
                    <div className="col mb-3">
                        <label className="label mb-2">Language</label>
                        <LimitedSelect
                            name="language"
                            isMulti
                            options={appState.languages}
                            className="basic-multi-select"
                            isClearable={true}
                            classNamePrefix="select"
                            placeholder="Select"
                            value={appState.selectedLanguage}
                            onChange={onLanguageChange}
                            valueMax={maxFilters}
                        />
                    </div>
                    <div className="col mb-3">
                        <label className="label mb-2">Country</label>
                        <LimitedSelect
                            name="country"
                            isMulti
                            options={appState.countries}
                            className="basic-multi-select"
                            isClearable={true}
                            classNamePrefix="select"
                            placeholder="Select"
                            value={appState.selectedCountry}
                            onChange={onCountryChange}
                            valueMax={maxFilters}
                        />
                    </div>
                    <div className="col mb-3">
                        <label className="label mb-2">Crop</label>
                        <LimitedSelect
                            name="crop"
                            isMulti
                            options={appState.crops}
                            className="basic-multi-select"
                            isClearable={true}
                            classNamePrefix="select"
                            placeholder="Select"
                            value={appState.selectedCrop}
                            onChange={onCropChange}
                            valueMax={maxFilters}
                        />
                    </div>
                    <div className="col mb-3">
                        <label className="label mb-2">Type</label>
                        <ul className="type">
                            {appState.typecount.map((s, i) => (
                                <li className="mb-3" key={i}>
                                    <label>
                                        <input
                                            type="radio"
                                            name="type"
                                            className="me-2"
                                            value={s.name === typeConst.allDevices ? "" : s.name}
                                            onChange={onTypeChange}
                                            checked={
                                                (appState.type === "" &&
                                                    s.name === typeConst.allDevices) ||
                                                appState.type === s.name
                                            }
                                        />
                                        {helpers.getTypeName(s.name)}({s.value})
                                    </label>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
            <div className="col-lg-9 results">
                <div className="row row-cols-1 row-cols-lg-2 mb-3 result-header">
                    {appState.results.length > 0 && !loadingState ? (
                        <div className="col ">
                            <label className="noofresult">
                                {appState.resultCount} results found
                            </label>
                        </div>
                    ) : null}
                    <div className="col">

                        <div
                            className={
                                appState.results.length > 0
                                    ? "row row-cols-2 row-cols-lg-1"
                                    : "row row-cols-1 row-cols-lg-1"
                            }
                        >




                            {appState.results.length > 0 && !loadingState ? (
                                <>
                                    <div className="row">
                                        <div className="col-sm">
                                            <label className="sortby row">
                                                <span className="me-2 col-md pr-0">Results per page</span>
                                                <Select
                                                    name="sortby"
                                                    options={appState.pageSizeList}
                                                    className="basic-multi-select col-md"
                                                    isClearable={false}
                                                    classNamePrefix="select"
                                                    isSearchable={false}
                                                    onChange={onPageSizeChange}
                                                    value={appState.pageSize}
                                                />
                                            </label>
                                        </div>
                                        <div className="col-sm pr-0">
                                            <label className="sortby row mx-0">
                                                <span className="me-2 col-md text-end px-0">Sort by</span>
                                                <Select
                                                    name="sortby"
                                                    options={appState.orderList}
                                                    className="basic-multi-select col-md px-0"
                                                    isClearable={false}
                                                    classNamePrefix="select"
                                                    isSearchable={false}
                                                    onChange={onSortOrderChange}
                                                    value={appState.order}
                                                />
                                            </label>
                                        </div>
                                    </div>
                                </>
                            ) : null}
                            <div className="col mobile-filter">
                                <label onClick={() => setMobileFilterState(true)}>
                                    <FilterIcon />{" "}
                                    <span>Filter({filtersCountForMobile(appState)})</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                {loadingState ? (
                    <LoadingComponent />
                ) : appState.results.length > 0 ? (
                    <>
                        <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 display-flex">
                            {appState.results.map((s, i) => (
                                <div className="col" key={i}>
                                    <SearchResultItem
                                        item={s}
                                        index={i}
                                        maxTermsToShow={maxTermsToShow}
                                        onclickShowMore={onclickShowMore}
                                    />
                                </div>
                            ))}
                        </div>
                        {Math.ceil(appState.resultCount / settings.pageSize) > 1 ? (
                            <div className="row row-cols-1 ">
                                <div className="col page">
                                    <ReactPaginate
                                        breakLabel="..."
                                        nextLabel=">"
                                        onPageChange={handlePageClick}
                                        pageRangeDisplayed={5}
                                        pageCount={Math.ceil(
                                            appState.resultCount / appState.pageSize.value
                                        )}
                                        previousLabel="<"
                                        renderOnZeroPageCount={null}
                                        forcePage={appState.page - 1}
                                    />
                                </div>
                            </div>
                        ) : null}
                    </>
                ) : (
                    <div className="row row-cols-1 ">
                        <NoResult />
                    </div>
                )}
            </div>
        </div>
    );
}

function SearchResultItem(props) {
    const { maxTermsToShow, index, onclickShowMore } = props;

    return (
        <div className="item">
            <a
                href={props.item.url}
                className="desc"
                target="_blank"
                rel="noreferrer"
            >
                <div className="logo">
                    <img src={props.item.icon} alt="" />
                </div>
                <div className="title">
                    <span className="name">{props.item.title}</span>
                    <span className="developed">{props.item.owner}</span>
                </div>
            </a>
            <div className="meta-data mt-2 seperator">
                <p className="desc">
                    <a
                        href={props.item.url}
                        className="desc"
                        target="_blank"
                        rel="noreferrer"
                    >
                        {props.item.description}{" "}
                    </a>
                </p>
            </div>
            {/* <div className="meta-data mt-2 seperator">
        <ul>
          <li>Identification</li>
          <li className="identification">{props.item.identifier}</li>
        </ul>
      </div> */}
            {Array.isArray(props.item.categories) &&
                props.item.categories.length > 0 ? (
                <div className="meta-data mt-2 seperator">
                    <ul>
                        {props.item.categories.map((s, i) => (
                            <li
                                key={i}
                                className={
                                    i >= maxTermsToShow && !(props.item.categoryshowmore ?? false)
                                        ? "d-none"
                                        : ""
                                }
                            >
                                {s.name}
                            </li>
                        ))}
                    </ul>
                    {props.item.categories.length > maxTermsToShow ? (
                        <label
                            className="showmore"
                            onClick={(e) => onclickShowMore("category", index)}
                        >
                            {props.item.categoryshowmore ?? false ? "Show less" : "Show more"}
                        </label>
                    ) : null}
                </div>
            ) : null}
            {Array.isArray(props.item.countries) &&
                props.item.countries.length > 0 ? (
                <div className="meta-data mt-2 seperator">
                    <ul>
                        {props.item.countries.map((s, i) => (
                            <li
                                key={i}
                                className={
                                    i >= maxTermsToShow && !(props.item.countryshowmore ?? false)
                                        ? "d-none"
                                        : ""
                                }
                            >
                                {s.name}
                            </li>
                        ))}
                    </ul>
                    {props.item.countries.length > maxTermsToShow ? (
                        <label
                            className="showmore"
                            onClick={(e) => onclickShowMore("country", index)}
                        >
                            {props.item.countryshowmore ?? false ? "Show less" : "Show more"}
                        </label>
                    ) : null}
                </div>
            ) : null}
            {Array.isArray(props.item.languages) &&
                props.item.languages.length > 0 ? (
                <div className="meta-data mt-2 seperator">
                    <ul>
                        {props.item.languages.map((s, i) => (
                            <li
                                key={i}
                                className={
                                    i >= maxTermsToShow && !(props.item.languageshowmore ?? false)
                                        ? "d-none"
                                        : ""
                                }
                            >
                                {s.name + " "}
                            </li>
                        ))}
                    </ul>
                    {props.item.languages.length > maxTermsToShow ? (
                        <label
                            className="showmore"
                            onClick={() => onclickShowMore("language", index)}
                        >
                            {props.item.languageshowmore ?? false ? "Show less" : "Show more"}
                        </label>
                    ) : null}
                </div>
            ) : null}
            {Array.isArray(props.item.crops) && props.item.crops.length > 0 ? (
                <div className="meta-data mt-2 seperator">
                    <ul>
                        {props.item.crops.map((s, i) => (
                            <li
                                key={i}
                                className={
                                    i >= maxTermsToShow && !(props.item.cropshowmore ?? false)
                                        ? "d-none"
                                        : ""
                                }
                            >
                                {s.preferredName + " "}
                            </li>
                        ))}
                    </ul>
                    {props.item.crops.length > maxTermsToShow ? (
                        <label
                            className="showmore"
                            onClick={() => onclickShowMore("crop", index)}
                        >
                            {props.item.cropshowmore ?? false ? "Show less" : "Show more"}
                        </label>
                    ) : null}
                </div>
            ) : null}
            <div className="meta-data mt-2">
                <ul>
                    <li>{helpers.getTypeName(props.item.type)}</li>
                </ul>
            </div>
        </div>
    );
}

function NoResult() {
    return (
        <div className="noresult">
            <NoResultIcon />
            <span className="tryagain">
                We found no tools for your search, try again!
            </span>
            <span className="pickcategory">Pick categories to start exploring</span>
            <div className="crop-app-index category" data-widget="category">
                <Categories />
            </div>
        </div>
    );
}

function LoadMore() {
    return (
        <div className="noresult">
            Load more
        </div>
    );
}

function useWindowSize() {
    const [windowSize, setWindowSize] = useState({
        width: undefined,
        height: undefined,
    });
    useEffect(() => {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    return windowSize;
}

const LimitedSelect = ({ valueMax, ...props }) => {
    return (
        <Select
            {...props}
            options={props.value.length >= valueMax ? [] : props.options}
            noOptionsMessage={() => {
                return props.value.length >= valueMax
                    ? "You've reached the max options value"
                    : "No options available";
            }}
        />
    );
};

export default Search;
